import { JhTable } from "designPackages/tablePackage";
import TableSkeleton from "./TableSkeleton";
interface BaseTableProps {
  isLoading?: boolean;
  children: React.ReactNode;
  className?: string;
}

const BaseTable = ({
  isLoading = false,
  children,
  className = ""
}: BaseTableProps) => {
  if (isLoading) {
    return <TableSkeleton />;
  }

  return (
    <div id="th-v2-base-table-container" className={`overflow-x-auto tw-root ${className}`}>
      <JhTable className="bg-white w-full max-sm:w-[1000px]">
        {children}
      </JhTable>
    </div>
  );
};

export default BaseTable;
